export const selectIsReady = ({sheet, blueprint}) => sheet.ready && blueprint.ready;
